import App from '@triotech/vue-core/src/lib/core/app';
import Vue from '@triotech/vue-core/src/vendor/vue';

import '@triotech/vue-core/src/vendor/bootstrap';
import '@triotech/vue-core/src/lib/ui/modal';
import '@triotech/vue-core/src/lib/ui/scroll-to';
import '@triotech/vue-core/src/lib/ui/notification';
import '@triotech/vue-core/src/lib/helper/window';
import '@triotech/vue-core/src/vendor/jquery';
import '@triotech/vue-core/src/vendor/trio-icons';
import '@triotech/vue-core/src/vendor/moment';
import '@triotech/vue-core/src/vendor/font-awesome';
import '@triotech/vue-core/src/vendor/google/analytics';
import '@triotech/vue-core/src/vendor/vue-form-generator/fields';
import '@triotech/vue-core/src/vendor/toggle-button';
import '@triotech/vue-core/src/vendor/socket-io';
import '@triotech/vue-core/src/vendor/google/maps';
import '@triotech/vue-core/src/lib/ui/image';

const { methods } = Vue.config.optionMergeStrategies;
Vue.config.optionMergeStrategies.methods = (parentVal, childVal, vm, key) => {
  const merged = methods(parentVal, childVal, vm, key);

  if (parentVal && parentVal.catchHandler && childVal && childVal.catchHandler) {
    merged.parentCatchHandler = parentVal.catchHandler;
  }

  return merged;
};

App.autoload(require.context('@/plugins', false, /\.js$/));

App.$bus.$on('ready', () => {
  App.run({
    mixins: [{
      methods: {
        canManage() {
          return this.$helper.canManage();
        },
        isDemo() {
          return this.$helper.isDemo();
        },
      },
    }],
  });
});



// WEBPACK FOOTER //
// ./src/main.js